module.exports = __webpack_public_path__ + "static/early-prototype-7112d8c5dc2c59a32de13a30e1537262.png";